import SpacedItems from 'shared/components/ui/SpacedItems'
import { Button } from 'shared/ui'

export default function SettingsSideBarActions({ onClose, onSave }) {
  return (
    <SpacedItems.Container direction="vertical">
      <SpacedItems.Item>
        <Button size="large" fluid primary onClick={onSave}>
          Save preferences
        </Button>
      </SpacedItems.Item>
      <SpacedItems.Item>
        <Button size="large" fluid basic onClick={onClose}>
          Cancel
        </Button>
      </SpacedItems.Item>
    </SpacedItems.Container>
  )
}
